import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api, apiWrite } from './api'

/** Public view of a key. The server never sends the hash, and sends the plaintext only once. */
export interface APIKeyRow {
  id: string
  name: string
  prefix: string
  scopes: string[]
  created_by?: string
  last_used_at?: string
  revoked_at?: string
  created_at: string
}

export interface CreatedAPIKey {
  api_key: APIKeyRow
  key: string
}

export const apiKeyQueryKey = ['api-keys'] as const

export const scopeLabel: Record<string, string> = {
  read: 'อ่าน',
  write: 'เขียน',
  admin: 'ผู้ดูแล',
}

export const scopeHint: Record<string, string> = {
  read: 'เรียกดูข้อสังเกต เอกสาร และรายงาน',
  write: 'สร้างและแก้ไขข้อมูลในนามขององค์กร',
  admin: 'จัดการการตั้งค่าและคีย์อื่น',
}

export function useAPIKeys() {
  return useQuery({
    queryKey: apiKeyQueryKey,
    queryFn: () => api<APIKeyRow[]>('/v1/api-keys'),
    staleTime: 15_000,
  })
}

export function useCreateAPIKey() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: { name: string; scopes: string[] }) =>
      apiWrite<CreatedAPIKey>('/v1/api-keys', 'POST', input),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: apiKeyQueryKey }) },
  })
}

export function useRevokeAPIKey() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => apiWrite<APIKeyRow>(`/v1/api-keys/${id}/revoke`, 'POST', {}),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: apiKeyQueryKey }) },
  })
}
